import omit from 'lodash/omit'

const sanitize = (x) => omit(x, ['channel', 'event', 'seqnum'])

export default sanitize
